import { type ReactNode } from 'react';

const SLIDER_CLS =
  'w-full appearance-none bg-transparent accent-brand-red ' +
  '[&::-webkit-slider-runnable-track]:h-1 [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-white/10 ' +
  '[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:-mt-[6px] [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-brand-red [&::-webkit-slider-thumb]:shadow ' +
  '[&::-moz-range-track]:h-1 [&::-moz-range-track]:rounded-full [&::-moz-range-track]:bg-white/10 ' +
  '[&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:bg-brand-red';

function ZoomLabel({ value }: { value: number }): ReactNode {
  return (
    <div className="flex items-center justify-between text-[10px] uppercase tracking-wider text-text-tertiary/70">
      <span>Zoom</span>
      <span>{value.toFixed(1)}x</span>
    </div>
  );
}

export function ZoomSlider({
  value,
  min,
  onChange,
}: {
  value: number;
  min: number;
  onChange: (z: number) => void;
}): ReactNode {
  return (
    <div className="space-y-xs">
      <ZoomLabel value={value} />
      <input
        type="range"
        min={min}
        max={Math.max(min * 3, 4)}
        step={0.01}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className={SLIDER_CLS}
      />
    </div>
  );
}
